// extracted by css-extract-rspack-plugin
export default {"editor":"bD4aN","editorContent":"aki0M","img":"uWdYT"};